export const fontFamilies = ["Coconat", "Apfel Grotezk", "Mattone", "Sinistre"];
